export const RESERVATION_STATUS_CANCELED = 'CANCELED';
export const RESERVATION_STATUS_CONFIRMED = 'CONFIRMED';

export const enum ReservationStatusType {
  PENDING = 'PENDING',
  IGNORE = 'IGNORE',
  COMMIT = 'COMMIT'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/reservation-status.model.ts